/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * ProVersion Platform API
 * RECORTE GERADO — nao editar. Produzido por front/scripts/normative-contract.mjs
 * a partir de contract/openapi.yaml, contendo apenas operacoes `x-maturity: normative`.
 *
 * OpenAPI spec version: 0.1.0
 */

/**
 * `excused` so pode aparecer como ajuste do Super Admin; o projetor de
 * presenca nunca o apura sozinho.
 */
export type AttendanceStatus = typeof AttendanceStatus[keyof typeof AttendanceStatus];


export const AttendanceStatus = {
  present: 'present',
  late: 'late',
  absent: 'absent',
  excused: 'excused',
  cancelled_by_school: 'cancelled_by_school',
} as const;
